import { useCallback, useEffect, useState } from "react"
import { createMainSiteContent, deleteMainSiteContent, fetchAllMainSiteContent, fetchSiteNamesList, patchMainSiteContentStatus, updateMainSiteContent } from "./main-site-content.service"

export const useCreateMainSiteContent = () => {
  const [isLoading, setIsLoading] = useState(false)
  const [error, setError] = useState(null)
  const isError = Boolean(error)

  const createContent = async (data) => {
    try {
      setIsLoading(true)
      setError(null)
      await createMainSiteContent(data)
      return true
    } catch (err) {
      setError(err)
      return false
    } finally {
      setIsLoading(false)
    }
  }

  return { isLoading, error, isError, createContent }
}

export const useAllMainSiteContent = (filters = {}) => {
  const [content, setContent] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState(null);

  const isError = Boolean(error);
  const { type } = filters;

  const fetchContent = useCallback(async () => {
    try {
      setIsLoading(true);
      setError(null);

      const data = await fetchAllMainSiteContent({ type });
      setContent(data?.contents || []);
    } catch (err) {
      setError(err);
    } finally {
      setIsLoading(false);
    }
  }, [type]);

  useEffect(() => {
    fetchContent();
  }, [fetchContent]);

  return { content, isLoading, error, isError, refetch: fetchContent };
};

export const useUpdateMainSiteContent = () => {
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(null);

  const isError = Boolean(error);

  const updateContent = async (id, data) => {
    try {
      setIsLoading(true);
      setError(null);

      await updateMainSiteContent(id, data);

      return true; // return success flag if you want
    } catch (err) {
      setError(err);
      console.error("Failed to update main site content:", err);
      return false;
    } finally {
      setIsLoading(false);
    }
  };

  return { isLoading, error, isError, updateContent };
};

export const useDeleteMainSiteContent = () => {
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(null);

  const isError = Boolean(error);

  const deleteContent = async (id) => {
    try {
      setIsLoading(true);
      setError(null);

      await deleteMainSiteContent(id);

      return true;
    } catch (err) {
      setError(err);
      console.error("Failed to delete main site content:", err);
      return false;
    } finally {
      setIsLoading(false);
    }
  };

  return { isLoading, error, isError, deleteContent };
};

export const useMainSiteContentNamesList = () => {
  const [namesList, setNamesList] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState(null);

  const isError = Boolean(error);

  const fetchNamesList = useCallback(async () => {
    try {
      setIsLoading(true);
      setError(null);

      const data = await fetchSiteNamesList();
      setNamesList(data.results || []);
    } catch (err) {
      setError(err);
    } finally {
      setIsLoading(false);
    }
  }, []);

  useEffect(() => {
    fetchNamesList();
  }, [fetchNamesList]);

  return { namesList, isLoading, error, isError, refetch: fetchNamesList };
};

export const useToggleMainSiteContentStatus = () => {
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(null);

  const isError = Boolean(error);

  const toggleStatus = async (id) => {
    try {
      setIsLoading(true);
      setError(null);

      await patchMainSiteContentStatus(id);

      return true;
    } catch (err) {
      setError(err);
      console.error("Failed to toggle main site content status:", err);
      return false;
    } finally {
      setIsLoading(false);
    }
  };

  return { isLoading, error, isError, toggleStatus };
};
